import { ProfileDocument } from "@/data/interfaces/ProfileDocument";
import api from "./api";

const profileDocumentService = {
  getDocuments: async () => {
    const resp = await api.get("/profile/documents");
    return resp.data.data as ProfileDocument[];
  },

  uploadDocument: async (type: string, file: File) => {
    const formData = new FormData();
    formData.append("type", type);
    formData.append("document", file);

    const resp = await api.post("/profile/documents", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resp.data.data as ProfileDocument;
  },
};

export default profileDocumentService;
